(() => {
  function bind(root) {
    const host = root.querySelector('[data-efe-quick-payment]');
    const dialog = root.querySelector('[data-hw-product-dialog]');
    const dataNode = root.querySelector('[data-hw-data]');
    if (!host || !dialog || !dataNode || host.dataset.bound) return;
    let products;
    try { products = JSON.parse(dataNode.textContent).products; } catch (_) { return; }
    host.dataset.bound = 'true';
    const body = host.querySelector('[data-efe-quick-body]');
    const status = host.querySelector('[data-efe-quick-status]');
    let currentProduct = null;
    let controller = null;
    let generation = 0;

    function clear() {
      generation += 1;
      controller?.abort();
      controller = null;
      body.replaceChildren();
      host.removeAttribute('aria-busy');
      status.textContent = '';
    }

    async function renderPayment(product, variantId = '', restoreFocus = false) {
      clear();
      if (!product?.available || !product.url) { host.hidden = true; return; }
      host.hidden = false;
      host.setAttribute('aria-busy', 'true');
      status.textContent = host.dataset.loading;
      const requestGeneration = generation;
      controller = new AbortController();
      try {
        const url = new URL(product.url, window.location.origin);
        if (url.origin !== window.location.origin) throw new Error('Invalid product origin');
        url.searchParams.set('section_id', 'efe-quick-payment');
        if (variantId) url.searchParams.set('variant', variantId);
        else url.searchParams.delete('variant');
        const previewTheme = new URLSearchParams(window.location.search).get('preview_theme_id');
        if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
        const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) throw new Error('Payment section unavailable');
        const markup = await response.text();
        if (requestGeneration !== generation || currentProduct !== product || !dialog.open) return;
        const form = new DOMParser().parseFromString(markup, 'text/html').querySelector('[data-efe-quick-form]');
        if (!form?.dataset.productId) throw new Error('Product form missing');
        if (variantId && form.dataset.selectedVariant !== variantId) throw new Error('Variant mismatch');
        body.replaceChildren(document.importNode(form, true));
        status.textContent = '';
        if (restoreFocus) body.querySelector('[data-efe-quick-variant]')?.focus({ preventScroll: true });
      } catch (error) {
        if (error.name !== 'AbortError' && requestGeneration === generation) status.textContent = host.dataset.error;
      } finally {
        if (requestGeneration === generation) host.removeAttribute('aria-busy');
      }
    }

    root.addEventListener('efe:product-opened', event => {
      currentProduct = products.find(product => product.id === event.detail?.id) || null;
      renderPayment(currentProduct);
    });
    body.addEventListener('change', event => {
      const select = event.target.closest('[data-efe-quick-variant]');
      if (select && body.contains(select) && /^\d+$/.test(select.value)) renderPayment(currentProduct, select.value, true);
    });
    body.addEventListener('submit', event => {
      if (!body.querySelector('[data-efe-quick-wallet]')) event.preventDefault();
    });
    dialog.addEventListener('close', () => { currentProduct = null; clear(); host.hidden = true; });
  }

  function bindAll(scope = document) {
    if (scope.matches?.('[data-hw-root]')) bind(scope);
    scope.querySelectorAll('[data-hw-root]').forEach(bind);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bindAll(), { once: true });
  else bindAll();
  document.addEventListener('shopify:section:load', event => bindAll(event.target));
})();
